import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface ContainerProps {
  $isFocused: boolean;
  $isFilled: boolean;
  $isErrored: boolean;
}

interface ErrorProps {
  title?: string;
  children: React.ReactNode;
}

export const AutoGrowingContainer = styled.div<ContainerProps>`
  border: 2px solid #ccc;
  padding: 14px 16px;
  border-radius: 4px;
  min-height: 46px;
  color: #666360;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.$isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.$isFocused &&
    css`
      color: #107fc9;
      border-color: #107fc9;
    `}

  ${props =>
    props.$isFilled &&
    css`
      border-color: #ccc;
      color: #107fc9;
    `}

  textarea {
    flex: 1;
    background: transparent;
    border: 0;
    color: #333;

    &::placeholder {
      color: #808080;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Container = styled.div<ContainerProps>`
  border-radius: 4px;
  border: 2px solid #ccc;
  padding: 14px 16px;
  width: 100%;
  color: #666360;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.$isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.$isFocused &&
    css`
      color: #107fc9;
      border-color: #107fc9;
    `}

  ${props =>
    props.$isFilled &&
    css`
      border-color: #ccc;
      color: #107fc9;
    `}

  textarea {
    height: 100px;
    flex: 1;
    background: transparent;
    border: 0;
    color: #333;

    &::placeholder {
      color: #808080;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)<ErrorProps>`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
